
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, getAllNannyPaymentsApi } from '../../utils/Constants';

export const getAllNannyPayments = createAsyncThunk(
    "getAllPayments",
    async (_, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("Token")
            const config = {
                headers: {
                    "Authorization": token,
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                },
            };
            const response = await axios.get(
                `${BASE_URL}${getAllNannyPaymentsApi}`,
                config
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.message || "Failed to login."
            );
        }
    }
);

const paymentSlice = createSlice({
    name: "payments",
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {
        clearAllPaymentsData: (state) => {
            state.data = null;
            state.error = null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllNannyPayments.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllNannyPayments.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.token = action.payload.token;
            })
            .addCase(getAllNannyPayments.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});
export const { clearAllPaymentsData } = paymentSlice.actions;
export default paymentSlice.reducer;
